import React, { FC, PropsWithChildren } from 'react';
import { useLocation } from 'react-router';

import { DictionaryData, useTranslation } from 'app/lang';
import { ROUTE_PATH } from 'app/lib/routing/constants';
import { getDictionaryDataItems } from 'app/modules/Navigation/utils';

import styles from './TournamentsMenu.module.scss';

type LinkContentProps = PropsWithChildren<{
  caption?: string;
  label?: string | DictionaryData;
}>;

export const LinkContent: FC<LinkContentProps> = ({
  caption,
  label,
  children,
}) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isLive = pathname.startsWith(ROUTE_PATH.LIVE);

  return (
    <>
      <span data-test="item-label"
            className={styles.label}>
        {getDictionaryDataItems(t, label)}
      </span>
      {(caption && isLive) && (
        <span data-test="item-caption"
              className={styles.caption}>
          {caption}
        </span>
      )}
      {children}
    </>
  );
};
